import React from "react";

const PrimaryBtn = ({
  btnName = "Button",
  clickEvent,
  btnType = "button",
  extraClass = "",
  variant = "default",
  icon = null,

  /* 👇 OPTIONAL */
  isLoading = false,
}) => {
  return (
    <button
      type={btnType}
      onClick={isLoading ? undefined : clickEvent}
      disabled={isLoading}
      className={`
        relative
        inline-flex items-center justify-center gap-2
        w-full max-w-[350px] h-[50px]
        rounded-full border
        border-[rgb(254_105_67/1)]
        font-medium
        overflow-hidden
        transition-all duration-500 ease-in-out

        ${
          isLoading
            ? "cursor-not-allowed opacity-70"
            : `
              cursor-pointer
              text-[rgb(254_105_67/1)]
              [box-shadow:0_0_0_0_rgb(254_105_67/1)_inset]
              hover:text-white
              hover:[box-shadow:350px_350px_0_0_rgb(254_105_67/1)_inset]
            `
        }

        ${extraClass}
      `}
    >
      {/* Existing content (UNCHANGED) */}
      {variant === "isIcon" && icon && (
        <span className="flex items-center justify-center text-lg">{icon}</span>
      )}
      <span>{btnName}</span>

      {/* 🔄 Spinner overlay */}
      {isLoading && (
        <span className="absolute right-5 w-4 h-4 border-2 border-[rgb(254_105_67/1)] border-t-transparent rounded-full animate-spin" />
      )}
    </button>
  );
};

export default PrimaryBtn;
